import { Component, Output, Input, EventEmitter } from '@angular/core';

@Component({
    selector: 'mapp-navigate-buttons-page',
    templateUrl: './navigate-buttons-page.component.html',
    styleUrls: ['./navigate-buttons-page.component.scss'],
    standalone: false,
})
export class NavigateButtonsPageComponent {
    @Input() title: string;

    @Input() description: string;

    @Input() firstButtonText: string;

    @Input() secondButtonText: string;

    @Input() path: string;

    @Output() onFirstButtonClick: EventEmitter<any> = new EventEmitter<any>();

    @Output() onSecondButtonClick: EventEmitter<any> = new EventEmitter<any>();
}
